"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hfilterReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var HfilterState_init_1 = require("@/pages/search/states/HfilterState.init");
var HfilterAction_1 = require("@/pages/search/actions/HfilterAction");
var Area_1 = require("@/pages/search/states/Area");
exports.hfilterReducer = function (state, action) {
    if (state === void 0) { state = HfilterState_init_1.defaultHfilterState; }
    switch (action.type) {
        case typesafe_actions_1.getType(HfilterAction_1.default.onListingTypeToggle): {
            return __assign(__assign({}, state), { listingTypeActive: !state.listingTypeActive, districtActive: false, priceActive: false, sizeActive: false, amenityActive: false, bedsActive: false, propertyTypeActive: false, keywordActive: false, sortPanelActive: false });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onDistrictToggle): {
            return __assign(__assign({}, state), { listingTypeActive: false, districtActive: !state.districtActive, priceActive: false, sizeActive: false, amenityActive: false, bedsActive: false, propertyTypeActive: false, keywordActive: false, sortPanelActive: false });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onPriceToggle): {
            return __assign(__assign({}, state), { listingTypeActive: false, districtActive: false, priceActive: !state.priceActive, sizeActive: false, amenityActive: false, bedsActive: false, propertyTypeActive: false, keywordActive: false, sortPanelActive: false });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onSizeToggle): {
            return __assign(__assign({}, state), { listingTypeActive: false, districtActive: false, priceActive: false, sizeActive: !state.sizeActive, amenityActive: false, bedsActive: false, propertyTypeActive: false, keywordActive: false, sortPanelActive: false });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onBedsToggle): {
            return __assign(__assign({}, state), { listingTypeActive: false, districtActive: false, priceActive: false, sizeActive: false, bedsActive: !state.bedsActive, propertyTypeActive: false, amenityActive: false, keywordActive: false, sortPanelActive: false });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onPropertyTypeToggle): {
            return __assign(__assign({}, state), { listingTypeActive: false, districtActive: false, priceActive: false, sizeActive: false, bedsActive: false, propertyTypeActive: !state.propertyTypeActive, amenityActive: false, keywordActive: false, sortPanelActive: false });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onAmenityToggle): {
            return __assign(__assign({}, state), { listingTypeActive: false, districtActive: false, priceActive: false, sizeActive: false, bedsActive: false, propertyTypeActive: false, amenityActive: !state.amenityActive, keywordActive: false, sortPanelActive: false });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.closeAll): {
            return __assign(__assign({}, state), { listingTypeActive: false, districtActive: false, priceActive: false, sizeActive: false, bedsActive: false, propertyTypeActive: false, amenityActive: false, keywordActive: false, sortPanelActive: false });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setAreaExpanded): {
            var _a = action.payload, area_1 = _a.area, isExpanded_1 = _a.isExpanded;
            return __assign(__assign({}, state), { districts: state.districts.map(function (it) {
                    if (Area_1.parentToArea(it.id) === area_1) {
                        return __assign(__assign({}, it), { expanded: isExpanded_1 });
                    }
                    return it;
                }) });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setDistrictActive): {
            return __assign(__assign({}, state), { districts: state.districts.map(function (it) { return it.id === action.payload.id ? __assign(__assign({}, it), { selected: action.payload.active }) : it; }) });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.clearArea): {
            return __assign(__assign({}, state), { districts: state.districts.map(function (it) { return it.area === action.payload ? __assign(__assign({}, it), { selected: false }) : it; }) });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.selectAllArea): {
            return __assign(__assign({}, state), { districts: state.districts.map(function (it) { return it.area === action.payload ? __assign(__assign({}, it), { selected: true }) : it; }) });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onPriceMinChanged): {
            return __assign(__assign({}, state), { priceMin: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onPriceMaxChanged): {
            return __assign(__assign({}, state), { priceMax: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onSizeMinChanged): {
            return __assign(__assign({}, state), { sizeMin: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onSizeMaxChanged): {
            return __assign(__assign({}, state), { sizeMax: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onSizeMinMaxChanged): {
            return __assign(__assign({}, state), { sizeMin: action.payload.min, sizeMax: action.payload.max });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onPriceMinMaxChanged): {
            return __assign(__assign({}, state), { priceMin: action.payload.min, priceMax: action.payload.max });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onPriceClear): {
            return __assign(__assign({}, state), { priceMin: 0, priceMax: -1 });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onListingTypeSelect): {
            return __assign(__assign({}, state), { listingType: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onSizeClear): {
            return __assign(__assign({}, state), { sizeMin: 0, sizeMax: -1 });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onBedPresetClick): {
            var bedsPresets = state.bedsPresets.map(function (it) {
                return it.from === action.payload.from && it.to === action.payload.to
                    ? (__assign(__assign({}, it), { selected: it.selected ? false : true }))
                    : (__assign(__assign({}, it), { selected: false }));
            });
            return __assign(__assign({}, state), { bedsPresets: bedsPresets });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onBedClear): {
            return __assign(__assign({}, state), { bedsPresets: state.bedsPresets.map(function (it) { return (__assign(__assign({}, it), { selected: false })); }) });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onTypeClick): {
            var typeOptions = state.typeOptions.map(function (it) {
                return it.value === action.payload.value
                    ? (__assign(__assign({}, it), { selected: !it.selected }))
                    : it;
            });
            return __assign(__assign({}, state), { typeOptions: typeOptions });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onTypeClear): {
            var typeOptions = state.typeOptions.map(function (it) { return (__assign(__assign({}, it), { selected: false })); });
            return __assign(__assign({}, state), { typeOptions: typeOptions });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onAmenityClick): {
            var amenityOptions = state.amenityOptions.map(function (it) {
                return it.value === action.payload.value
                    ? (__assign(__assign({}, it), { selected: !it.selected }))
                    : it;
            });
            return __assign(__assign({}, state), { amenityOptions: amenityOptions });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onVrVideoClick): {
            var vrVideoPresets = state.vrVideoPresets.map(function (it) {
                return it.value === action.payload.value
                    ? (__assign(__assign({}, it), { selected: !it.selected }))
                    : it;
            });
            return __assign(__assign({}, state), { vrVideoPresets: vrVideoPresets });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onAmenitiesClear): {
            var amenityOptions = state.amenityOptions.map(function (it) { return (__assign(__assign({}, it), { selected: false })); });
            return __assign(__assign({}, state), { amenityOptions: amenityOptions });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setKeywordPanelActive): {
            return __assign(__assign({}, state), { listingTypeActive: false, districtActive: false, priceActive: false, sizeActive: false, bedsActive: false, propertyTypeActive: false, amenityActive: false, keywordActive: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setKeyword): {
            return __assign(__assign({}, state), { keyword: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setSearchFromSuggestion): {
            var suggestion = action.payload;
            return __assign(__assign({}, state), { keyword: suggestion.name, searchResultId: suggestion.id, searchResultType: suggestion.type });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onKeywordChanged): {
            return __assign(__assign({}, state), { keyword: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setKeywordSuggestionGroups): {
            return __assign(__assign({}, state), { keywordSuggestionGroups: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setKeywordHistoryGroups): {
            return __assign(__assign({}, state), { keywordHistoryGroups: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setKeywordLoading): {
            return __assign(__assign({}, state), { keywordSuggestionsLoading: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onDistrictClear): {
            return __assign(__assign({}, state), { districts: state.districts.map(function (it) { return (__assign(__assign({}, it), { selected: false })); }) });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onVrVideoClear): {
            return __assign(__assign({}, state), { vrVideoPresets: state.vrVideoPresets.map(function (it) { return (__assign(__assign({}, it), { selected: false })); }) });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setFullDistrictActive): {
            return __assign(__assign({}, state), { fullDistrictActive: action.payload, districts: action.payload ?
                    state.districts.map(function (it) { return it.area === null ? __assign(__assign({}, it), { expanded: true }) : it; }) : // Expand all area
                    state.districts.map(function (it) { return it.area === null ? (it.id === 1000 ? __assign(__assign({}, it), { expanded: true }) : __assign(__assign({}, it), { expanded: false })) : it; }) // Collpase all area except HKI
             });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setFullDistrictExpand): {
            return __assign(__assign({}, state), { fullDistrictExpand: !state.fullDistrictExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onFullDistrictToggle): {
            return __assign(__assign({}, state), { fullDistrictExpand: !state.fullDistrictExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setFullPriceExpand): {
            return __assign(__assign({}, state), { fullPriceExpand: !state.fullPriceExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onFullPriceToggle): {
            return __assign(__assign({}, state), { fullPriceExpand: !state.fullPriceExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setFullSizeExpand): {
            return __assign(__assign({}, state), { fullSizeExpand: !state.fullSizeExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onFullSizeToggle): {
            return __assign(__assign({}, state), { fullSizeExpand: !state.fullSizeExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setFullBedsExpand): {
            return __assign(__assign({}, state), { fullBedsExpand: !state.fullBedsExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onFullBedsToggle): {
            return __assign(__assign({}, state), { fullBedsExpand: !state.fullBedsExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setFullTypeExpand): {
            return __assign(__assign({}, state), { fullPropertyTypeExpand: !state.fullPropertyTypeExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onFullTypeToggle): {
            return __assign(__assign({}, state), { fullPropertyTypeExpand: !state.fullPropertyTypeExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setFullAmenitiesExpand): {
            return __assign(__assign({}, state), { fullAmenitiesExpand: !state.fullAmenitiesExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onFullAmenitiesToggle): {
            return __assign(__assign({}, state), { fullAmenitiesExpand: !state.fullAmenitiesExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setFullShowVrExpand): {
            return __assign(__assign({}, state), { fullShowVrExpand: !state.fullShowVrExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onFullShowVrToggle): {
            return __assign(__assign({}, state), { fullShowVrExpand: !state.fullShowVrExpand });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setFullKeywordPanelActive): {
            return __assign(__assign({}, state), { fullKeywordActive: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onSortOptionClicked): {
            return __assign(__assign({}, state), { sortOptions: state.sortOptions.map(function (it) { return action.payload.value === it.value ? (__assign(__assign({}, it), { selected: true })) : (__assign(__assign({}, it), { selected: false })); }) });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setSortPanelActive): {
            return __assign(__assign({}, state), { sortPanelActive: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setSortOpen): {
            return __assign(__assign({}, state), { sortFullActive: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.onSortMoreToggle): {
            return __assign(__assign({}, state), { listingTypeActive: false, districtActive: false, priceActive: false, sizeActive: false, bedsActive: false, propertyTypeActive: false, amenityActive: false, keywordActive: false, sortPanelActive: !state.sortPanelActive });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setFilterOpen): {
            return __assign(__assign({}, state), { filterFullActive: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setMapActive): {
            return __assign(__assign({}, state), { mapActive: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setHasUnsaved): {
            return __assign(__assign({}, state), { hasUnsaved: action.payload });
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setHfilter): {
            return __assign(__assign({}, state), action.payload);
        }
        case typesafe_actions_1.getType(HfilterAction_1.default.setSuggestionGroupRowIndex): {
            return __assign(__assign({}, state), { keywordGroupIndex: action.payload.groupIndex, keywordRowIndex: action.payload.rowIndex });
        }
        default: {
            return state;
        }
    }
};
